import { EStatus, FC, Props } from "./typings";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { validateEmail } from "utils/isEmail";

const Avatar: FC<Props> = ({
  avatar,
  name,
  className,
  circleClassName,
  status,
  size,
}) => {
  if (!name?.length) return <></>;

  const [chars, setChars] = useState<string>("");

  useEffect(() => {
    const email = validateEmail(name);

    if (email?.address) {
      if (email.label) {
        setChars(
          email.label
            .split(" ")
            .filter((_, index) => index < 2)
            .map((word) => word.charAt(0))
            .join(""),
        );
      } else {
        setChars(
          email.address
            .split(".")
            .filter((_, index) => index < 2)
            .map((word) => word.charAt(0))
            .join(""),
        );
      }
    } else {
      setChars(
        name
          .split(" ")
          .filter((_, index) => index < 2)
          .map((word) => word.charAt(0))
          .join(""),
      );
    }
  }, [name]);

  return (
    <div
      className={classNames(
        styles.wrapper,
        className,
        size === "small" ? styles.small : null,
        size === "large" ? styles.large : null,
      )}
    >
      {avatar && (
        <img src={avatar} className={classNames(styles.wrapper, className)} />
      )}
      {!avatar && (
        <div
          className={classNames(
            styles.avatar,
            circleClassName,
            size === "small" ? styles.small : null,
            size === "large" ? styles.large : null,
            "text-primary-500",
          )}
        >
          {chars}
        </div>
      )}
      {status === EStatus.ONLINE && <div className={styles.status}></div>}
    </div>
  );
};

export default Avatar;
